import axios from "axios";
import { basicurl } from "../ServiceUrl/url";

// const basicurl = basicurl;

const getToken = () => window.sessionStorage.getItem("user_token") || "";
const token = window.sessionStorage.getItem("user_token");

export const GetUniversityListService = async (page) => {
  const searchParam = page.search
    ? `&search=${encodeURIComponent(page.search)}`
    : "";
  const lightParam = page.light ? `&light=${page.light}` : "";
  let res = await axios.get(
    basicurl +
    `/api/university/get-all-university?limit=${page.limit}&page=${page.page}${searchParam}${lightParam}`,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};
export const GetAgentListService = async (page) => {
  const searchParam = page.search
    ? `&search=${encodeURIComponent(page.search)}`
    : "";
  let res = await axios.get(
    basicurl +
    `/api/login/get-all-active-agents?limit=${page.limit}&page=${page.page}&${searchParam}`,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};
export const GetUserListService = async (page) => {
  const searchParam = page.search
    ? `&search=${encodeURIComponent(page.search)}`
    : "";
  let res = await axios.get(
    basicurl +
    `/api/login/get-all-active-users?limit=${page.limit}&page=${page.page}&${searchParam}`,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};
export const GetCatalogListService = async (page) => {
  const searchParam = page.search
    ? `&search=${encodeURIComponent(page.search)}`
    : "";
  let res = await axios.get(
    basicurl +
    `/api/catalog/get-all-catalogs-or-brochures?limit=${page.limit}&page=${page.page}&${searchParam}`,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};
export const GetProgramListService = async (id, page) => {
  const searchParam = page.search
    ? `&search=${encodeURIComponent(page.search)}`
    : "";
  const url =
    id !== undefined
      ? `${basicurl}/api/program/get-all-programs?university=${id}`
      : `${basicurl}/api/program/get-all-programs?limit=${page.limit}&page=${page.page}&${searchParam}`;
  let res = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};
export const GetCountryListService = async (page) => {
  const searchParam = page.search
    ? `&search=${encodeURIComponent(page.search)}`
    : "";
  const url = `${basicurl}/api/country-state/get-all-counties-with-states?limit=${page.limit}&page=${page.page}&${searchParam}`;
  let res = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};

export const GetCurrencyListService = async () => {
  const url = `${basicurl}/api/currency/get-all-currencies`;
  let res = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};
export const GetDegreeListService = async () => {
  const url = `${basicurl}/api/degree/get-all-degrees`;
  let res = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};
export const GetContractListService = async (page, newToggleState) => {
  const searchParam = page.search
    ? `&search=${encodeURIComponent(page.search)}`
    : "";
  const url = `${basicurl}/api/contract-type/get-all-contract-types?limit=${page.limit}&page=${page.page}&isBlocked=${newToggleState}&${searchParam}`;
  let res = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};
export const GetStateListService = async (id) => {
  const url = `${basicurl}/api/country-state/states/${id}`;
  let res = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};
export const GetProcessListService = async (id, page) => {
  // let res = await axios.get(
  //   basicurl + "/api/process-sheet/get-all-process-sheets",
  //   {
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //     },
  //   }
  const searchParam = page.search
    ? `&search=${encodeURIComponent(page.search)}`
    : "";
  const url =
    id !== undefined
      ? `${basicurl}/api/process-sheet/get-all-process-sheets?universityId=${id}`
      : `${basicurl}/api/process-sheet/get-all-process-sheets?limit=${page.limit}&page=${page.page}&${searchParam}`;
  let res = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};
export const GetOrganizationListService = async (page) => {
  const searchParam = page.search
    ? `&search=${encodeURIComponent(page.search)}`
    : "";

  let res = await axios.get(
    basicurl +
    `/api/organization/get-all-organizations?limit=${page.limit}&page=${page.page}&${searchParam}`,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};
export const GetRoleListService = async () => {
  let res = await axios.get(basicurl + "/api/role/get-all-roles", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};
export const CreateUniversityService = async (data) => {
  let res = await axios.post(
    basicurl + "/api/university/add-university",
    data,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};
export const CreateOrganizationService = async (data) => {
  let res = await axios.post(
    basicurl + "/api/organization/add-organization",
    data,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};
export const CreateAgentService = async (data) => {
  let res = await axios.post(basicurl + "/api/login/create-agent", data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};
export const CreateUserService = async (data) => {
  let res = await axios.post(basicurl + "/api/login/create-CAE-user", data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};
export const CreateCatalogService = async (data) => {
  let res = await axios.post(
    basicurl + "/api/catalog/add-catalog-or-brochure",
    data,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};
export const CreateProgramService = async (data) => {
  let res = await axios.post(
    basicurl + "/api/program/add-multiple-programs",
    [data],
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};
export const CreateCountryService = async (data) => {
  let res = await axios.post(
    basicurl + "/api/country-state/save-update",
    data,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};
export const CreateDegreeService = async (data) => {
  let res = await axios.post(basicurl + "/api/degree/add-degree", data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};
export const CreateContractService = async (data) => {
  let res = await axios.post(
    basicurl + "/api/contract-type/save-contract-type",
    data,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};
export const CreateProcessService = async (data) => {
  let res = await axios.post(
    basicurl + "/api/process-sheet/add-process-sheet",
    data,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};

export const LoginService = async (data) => {
  let res = await axios.post(basicurl + "/api/login/user-login", data);
  return res;
};

export const changePasswordService = async (data) => {
  let res = await axios.post(basicurl + "/api/login/change-password", data, {
    headers: {
      Authorization: `Bearer ${window.sessionStorage.getItem(
        "user_first_token"
      )}`,
    },
  });
  return res;
};
export const AddtochatService = async (data) => {
  let res = await axios.post(basicurl + "/api/chat/add-message-to-chat", data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};
export const GetUserChatService = async () => {
  const authToken = getToken();
  let res = await axios.get(basicurl + `/api/chat/get-user-chats?_t=${Date.now()}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return res;
};

export const MarkedChatPinned = async (id, action = "pin") => {
  const authToken = window.sessionStorage.getItem("user_token") || token;
  let res = await axios.put(
    basicurl +
    "/api/chat/setPinnedAndUnpinnedChats?chatId=" +
    id +
    "&action=" +
    action,
    {},
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return res;
};

export const MarkedChatUnread = async (id) => {
  const authToken = window.sessionStorage.getItem("user_token") || token;
  let res = await axios.put(
    basicurl + "/api/chat/markMessagesAsUnseen/" + id,
    {},
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return res;
};

export const GetUserChatByIdService = async (data) => {
  //(data, "line 170");
  const authToken = getToken();
  let res = await axios.get(basicurl + `/api/chat/get-chat-by-id/${data}?_t=${Date.now()}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return res;
};
export const DeleteMsgFromChatService = async (personId, msgId) => {
  const authToken = getToken();
  let res = await axios.delete(
    basicurl + `/api/chat/delete-message-from-chat/${personId}/${msgId}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return res;
};
export const EditMsgToChatService = async (personId, msgId, data) => {
  const authToken = getToken();
  let res = await axios.put(
    basicurl +
    `/api/chat/edit-message-by-chatId-messageId/${personId}/${msgId}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return res;
};
export const GetBranchByOrganizationIdService = async (id) => {
  let res = await axios.get(
    basicurl + `/api/branch/get-branches-by-organisation/${id}`,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};
export const GetSettingCountService = async () => {
  let res = await axios.get(basicurl + `/api/login/settings-data-counter/`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};
export const CreateBranchByOrganizationIdService = async (data) => {
  let res = await axios.post(basicurl + `/api/branch/create-brach`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};
export const AddPersonChatService = async (data) => {
  const authToken = window.sessionStorage.getItem("user_token") || token;
  let res = await axios.post(basicurl + "/api/chat/create-new-chat", data, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return res;
};
export const AddGroupChatService = async (data) => {
  const authToken = window.sessionStorage.getItem("user_token") || token;
  let res = await axios.post(basicurl + "/api/chat/create-chat-group", data, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return res;
};

export const AddPersonToGroupChatService = async (chatId, data) => {
  const authToken = window.sessionStorage.getItem("user_token") || token;
  let res = await axios.post(
    basicurl + `/api/chat/add-participants-to-group-chat/${chatId}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return res;
};

export const RenameGroupChatService = async (chatId, groupName) => {
  const authToken = window.sessionStorage.getItem("user_token") || token;
  let res = await axios.put(
    basicurl + `/api/chat/rename-group-chat/${chatId}`,
    { groupName },
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return res;
};

// Hides the chat for the current user only - everybody else keeps it.
export const DeleteChatForMeService = async (chatId) => {
  let res = await axios.put(
    basicurl + `/api/chat/delete-chat-for-me/${chatId}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};

// Removes the current user from a group chat.
export const LeaveChatService = async (chatId) => {
  let res = await axios.put(
    basicurl + `/api/chat/leave-chat/${chatId}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};

export const RemovePersonToGroupChatService = async (chatId, data) => {
  let res = await axios.post(
    basicurl + `/api/chat/remove-participant-from-chat/${chatId}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};

// services for edit

export const EditUniversityService = async (data, id) => {
  let res = await axios.put(
    basicurl + `/api/university/update-university/${id}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};

export const EditCatalogService = async (data, id) => {
  let res = await axios.put(
    basicurl + `/api/catalog/update-catalogs-or-brochure/${id}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};

export const EditProgramService = async (data, id) => {
  let res = await axios.put(
    basicurl + `/api/program/update-program/${id}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};

export const EditOrganizationService = async (data) => {
  let res = await axios.put(
    basicurl + `/api/organization/update-organization`,
    data,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};

export const EditProcessService = async (data, id) => {
  let res = await axios.put(
    basicurl + `/api/process-sheet/update-process-sheet/${id}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};

export const EditContractService = async (data, id) => {
  let res = await axios.put(
    basicurl + `/api/contract-type/update-contract-type/${id}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};

export const EditAgentService = async (data, id) => {
  let res = await axios.put(basicurl + `/api/login/update-agent/${id}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};

export const EditUserService = async (data, id) => {
  let res = await axios.put(
    basicurl + `/api/login/update-CAE-user/${id}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};

export const GetFilteredUserService = async (data) => {
  let res = await axios.get(
    basicurl +
    `/api/chat/filter-user?searchItem=${data?.searchItem ? data.searchItem : ""
    }`,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};

export const EditOrgBlockedStatusService = async (data) => {
  let res = await axios.put(
    basicurl + `/api/organization/change-organisation-block-status/${data.id}`,
    {
      isBlocked: data.isBlocked,
    },
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};

export const EditUnivBlockedStatusService = async (data) => {
  let res = await axios.put(
    basicurl + `/api/university/block-or-unblock-university/${data.id}`,
    {
      isBlocked: data.isBlocked,
    },
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};

export const EditContractBlockedStatusService = async (data) => {
  let res = await axios.put(
    basicurl + `/api/contract-type/toggle-block-contract-type/${data.id}`,
    {
      isBlocked: data.isBlocked,
    },
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};

export const EditUserBlockedStatusService = async (data, payload) => {
  let res = await axios.put(
    basicurl + `/api/login/change-cae-user-status/${data.id}`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};


export const EditAgentBlockedStatusService = async (data, payload) => {
  let res = await axios.put(
    basicurl + `/api/login/change-agent-user-status/${data.id}`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};

export const ResetUserPasswordService = async (userId) => {
  let res = await axios.post(
    basicurl + `/api/login/reset-user-password/${userId}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};

export const AddDefaultIntakeService = async (data) => {
  let res = await axios.post(
    basicurl + `/api/student/save-default-intake`,
    data,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};

export const GetDefaultIntakeService = async () => {
  let res = await axios.get(basicurl + `/api/student/get-default-intake`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};

export const EditProgAvailableService = async (data, id) => {
  console.log(data, id);
  let res = await axios.put(
    basicurl + `/api/program/update-program-availablity/${id}`,
    { isAvailable: data },
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};

export const DeleteProgAvailableService = async (id) => {
  let res = await axios.delete(basicurl + `/api/program/delete-program/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};

export const DeleteBulkProgramService = async (ids) => {
  let res = await axios.delete(basicurl + `/api/program/bulk-delete-programs`, {
    data: { ids },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};

export const DeleteDegreeAvailableService = async (id) => {
  let res = await axios.delete(basicurl + `/api/degree/delete-degree/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};

/**
 * Replaces a country's states with exactly what is passed.
 *
 * Same endpoint as create, but with `replace: true` - without it the backend
 * merges, so a removed state would come straight back.
 */
export const UpdateCountryService = async (country, states) => {
  let res = await axios.post(
    basicurl + "/api/country-state/save-update",
    { country, states, replace: true },
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};

export const DeleteCountryAvailableService = async (id) => {
  let res = await axios.delete(
    basicurl + `/api/country-state/delete-country/${id}`,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};

export const UniversityDetailsService = async (id) => {
  let res = await axios.get(
    basicurl +
    `/api/university/get-university-details-with-programs-catalog-processsheets/${id}`,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
  return res;
};

export const PromotedUniversityService = async (id) => {
  let res = await axios.get(
    basicurl + `/api/university/get-all-university-without-token`
  );
  return res;
};

/**
 * Deletes an organization.
 *
 * The API answers 409 with { message, blockedBy: [{ section, count }] } when the
 * organization id is still assigned elsewhere, so callers must let the error
 * through rather than swallowing it — that payload is what the modal shows.
 */
export const DeleteOrganizationService = async (id) => {
  let res = await axios.delete(
    basicurl + `/api/organization/delete-organization/${id}`,
    {
      headers: {
        Authorization: `Bearer ${window.sessionStorage.getItem("user_token")}`,
      },
    }
  );
  return res;
};

/** Deletes a university. Answers 409 with `blockedBy`, same contract as above. */
export const DeleteUniversityService = async (id) => {
  let res = await axios.delete(
    basicurl + `/api/university/delete-university/${id}`,
    {
      headers: {
        Authorization: `Bearer ${window.sessionStorage.getItem("user_token")}`,
      },
    }
  );
  return res;
};

export const CheckEmailExistService = async (email) => {
  let res = await axios.post(
    basicurl + `/api/login/check-email`,
    { email },
    {
      headers: {
        Authorization: `Bearer ${window.sessionStorage.getItem("user_token")}`,
      },
    }
  );
  return res;
};
